"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "30", height: "30", viewBox: "0 0 30 30", className: "Icon toolbar-list-on", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "g",
            { transform: "translate(1 1)", fill: "none", fillRule: "evenodd" },
            _react2.default.createElement("path", { d: "M7.499 10.5a1.5 1.5 0 1 0-.001-2.999 1.5 1.5 0 0 0 .001 2.999zM7.499 15.5a1.5 1.5 0 1 0-.001-2.999 1.5 1.5 0 0 0 .001 2.999zM7.499 20.5a1.5 1.5 0 1 0-.001-2.999 1.5 1.5 0 0 0 .001 2.999zM12 8h10v2H12zM12 13h10v2H12zM12 18h10v2H12z", fill: "#4C4C4C" }),
            _react2.default.createElement("rect", { stroke: "#000", width: "28", height: "28", rx: "2.4", strokeWidth: "2" })
        )
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/small/jsx/toolbar-list-on.js
// module id = 1887
// module chunks = 0